﻿export const travelDocuments = () => {
    const selectors = {
        carAdminPlusButton: '.car-admin__plus-button',
        submitButton: '.form-button-group__submit-btn',
        additionalDriverInputBox: '.additionalDriverInputBox'
    };

    const elements = {
        input: 'input', 
        button: 'button', 
        p: 'p'
    }

    const elementIds = {
        removeRow: 'removeRow',
        additionalDrivers: 'additional-drivers-'
    };

    const classNames = {
        formFieldGroup: 'form-field-group',
        carAdminMinusButton: 'car-admin__minus-button',
        additionalDriverInputClass: 'form-field-group__input car-admin__input additionalDriverInputBox additional-drivers-disabled'
    };

    const attributeNames = {
        id: 'id',
        zero: '0',
        class: 'class',
        name: 'name',
        maxLength: 'maxLength', 
        placeholder: 'placeholder',
        type: 'type',
        value: 'value', 
        readonly: 'readonly',
        dataCy: 'data-cy',
        ariaLabel: 'aria-label',
        title: 'title'
    }

    let rowCount = 1;
    const maxAdditionalRows = 3;
    const maxTotalRows = 4;

    const init = () => 
    {
        const addButton = document.querySelector(selectors.carAdminPlusButton);
        addButton && addButton.addEventListener('click', () => {
            let inputs = document.querySelectorAll(selectors.additionalDriverInputBox);
            if(inputs.length <= maxAdditionalRows && inputs[0].value)
            addRow();
        });
    };

    const removeRow = (number) => {
        let removeButton = document.getElementById(elementIds.removeRow + number.toString());
        if (removeButton.parentNode) {
            removeButton.parentNode.removeChild(removeButton);
        }

        let driverInput = document.getElementById(elementIds.additionalDrivers + number.toString());
        if (driverInput.parentNode) {
            driverInput.parentNode.removeChild(driverInput);
        }
    
        let lineBreak = document.getElementsByTagName(elements.p);
        lineBreak[1].parentNode.removeChild(lineBreak[1]);
        let newId = number;
        for (let i = 1; i < maxTotalRows; i++) {
            const userInput = document.getElementById(elementIds.additionalDrivers + `${number + i}`);
    
        if (userInput) {
            userInput.setAttribute(attributeNames.id, elementIds.additionalDrivers + newId.toString());
            userInput.setAttribute(attributeNames.name, `AdditionalDrivers[${newId.toString() }]`);
            
            const removeBtn = document.getElementById(elementIds.removeRow +`${number + i}`);
            removeBtn.setAttribute(attributeNames.id, elementIds.removeRow + newId.toString());

            removeBtn && removeBtn.addEventListener('click', function () {
            let buttonId = this.id.slice(-1);
            let idToRemove = parseInt(buttonId);
    
            removeRow(idToRemove);
                });
                newId++;
            } else {
                break;
            }
        }
    }

    const addRow = () => 
    {
        const userInput = document.getElementById(elementIds.additionalDrivers + attributeNames.zero).value;
        let inputText = userInput.toString();
        document.getElementById(elementIds.additionalDrivers + attributeNames.zero).value = '';

        const newNameInput = document.createElement(elements.input);
        const removeRowButton = document.createElement(elements.button);

        newNameInput.setAttribute(attributeNames.class, classNames.additionalDriverInputClass);
        newNameInput.setAttribute(attributeNames.id, elementIds.additionalDrivers + rowCount.toString());
        newNameInput.setAttribute(attributeNames.maxLength, "30");
        newNameInput.setAttribute(attributeNames.name, "AdditionalDrivers[" + rowCount.toString() +"]");
        newNameInput.setAttribute(attributeNames.placeholder, inputText);
        newNameInput.setAttribute(attributeNames.type, "text");
        newNameInput.setAttribute(attributeNames.value, inputText);
        newNameInput.setAttribute(attributeNames.readonly, "true");
        
        removeRowButton.setAttribute(attributeNames.id, elementIds.removeRow + rowCount.toString());
        removeRowButton.innerHTML = "-"
        removeRowButton.setAttribute(attributeNames.class, classNames.carAdminMinusButton);
        removeRowButton.setAttribute(attributeNames.dataCy, "remove-driver-button")
        removeRowButton.setAttribute(attributeNames.ariaLabel, "Remove additional driver")
        removeRowButton.setAttribute(attributeNames.title, "Remove additional driver")
        
        removeRowButton && removeRowButton.addEventListener('click', function() {
            let buttonId = this.id.slice(-1);
            let idToRemove = parseInt(buttonId);

            removeRow(idToRemove);
        });

        const item = document.getElementsByClassName(classNames.formFieldGroup)[2];
        item.append(document.createElement(elements.p));
        item.append(newNameInput);
        item.append(removeRowButton);

        rowCount++
    }

    return {
        init
    };
}
